import ufeApi from 'services/api/ufeApi';
import { gqlClient } from 'services/api/gql/gqlClient';
import { CancelOrder } from 'constants/gql/mutations/checkout/cancelOrder.gql';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Order+Cancel+API

function cancelOrder(params = {}) {
    const oxsUrl = '/api/checkout/orders/cancel';

    const globalEnabled = Sephora?.configurationSettings?.oisMigration?.global?.isEnabled;
    const cancelEnabled = Sephora?.configurationSettings?.oisMigration?.cancel?.isEnabled;

    const shouldUseOIS = globalEnabled && cancelEnabled;

    if (shouldUseOIS) {
        return gqlClient
            .query({
                operationName: 'CancelOrder',
                query: CancelOrder,
                variables: {
                    input: params
                }
            })
            .then(data => data?.cancelOrder ?? data);
    }

    return ufeApi
        .makeRequest(oxsUrl, {
            method: 'POST',
            body: JSON.stringify(params)
        })
        .then(data => (data?.errorCode ? Promise.reject(data) : data));
}

export default cancelOrder;
